// Warmup exercises organized by phase and category
export const WARMUP_EXERCISES = {
  phase_1: {
    categories: [
      {
        id: 'movement_prep',
        name: 'Movement Prep',
        sequence: 0,
        exercises: [
          { id: 'x5hfz1-3TSmwDNTGtE9IKg', name: 'Wall ankle mobility', video: 'https://youtu.be/OMYuYGRABGE', documentation: '10/side', sequence: 0 },
          { id: 'g4gOzAMnTjS53pOyDNwXAA', name: 'Supine hamstring stretch', video: 'https://youtu.be/pvbT5CTb9VQ', documentation: '10/side', sequence: 1 },
          { id: '5rCk3EyKR.KHtJ.5p-2V1w', name: '90/90 hip switches (hands on floor)', video: 'https://youtu.be/qkCWpfd1RGE', documentation: '5/side', sequence: 2 },
          { id: 'GfP.fUSBTseA9ZInz2CnbQ', name: 'Half-kneeling hip flexor', video: 'https://youtu.be/Uob2vg2vUiE', documentation: '10/side', sequence: 3 },
          { id: '2.7m8c5iTgSOB1OcQhqidg', name: 'Kneeling adductor', video: 'https://youtu.be/r7fMc4mtxxM', documentation: '10 reps', sequence: 4 },
          { id: 'doVbeARsR9msScdJEZC8kg', name: 'Cat-cow', video: 'https://youtu.be/ZXzSu2vgqg8', documentation: '5/position', sequence: 5 },
          { id: '2YJFHuXyQimYDXB2xDwgbw', name: "World's greatest stretch", video: 'https://youtu.be/x5AsDiw4zwU', documentation: '5/side', sequence: 6 },
          { id: '7OXSBcsnQGO08LflK0wcFQ', name: 'Open books', video: 'https://youtu.be/5MrA6fabKBA', documentation: '10/side', sequence: 7 },
        ]
      },
      {
        id: 'speed_agility_locomotion',
        name: 'Speed/Agility/Locomotion',
        sequence: 1,
        exercises: [
          { id: 'uaw59bEFRyKpkzpgMqdwGg', name: 'Marching (linear and lateral)', video: 'https://youtu.be/ga7aufX9s4A', documentation: '10 yards', sequence: 8 },
          { id: 'FMtr-tI4T.-H1Sh78TmGrQ', name: 'Wall march', video: 'https://youtu.be/0W1P7o25hRM', documentation: '10/side', sequence: 9 },
          { id: 'trDP4sUQTia7SZreBCIlQA', name: 'Bear crawl (forward/backward)', video: 'https://youtu.be/OY8OvtkblzE', documentation: '10 yards/direction', sequence: 10 },
          { id: '7EFUcYepRb6Wd6tsAy5hvA', name: 'Crab walk (forward/backward)', video: 'https://youtu.be/_2Kg371v0mk', documentation: '10 yards/direction', sequence: 11 },
          { id: 'FaTuk5zHR9SYPmY8OTf5jg', name: 'Toy soldiers', video: 'https://youtu.be/SFfETP_m1rM', documentation: '10 yards', sequence: 12 },
          { id: 'S6ElP.WKQAm1jIcO1mAkWw', name: 'Inchworm', video: 'https://youtu.be/CVg_31nF2fk', documentation: '10 yards', sequence: 13 },
          { id: '5hR7cNjoTouiwCzeruyK2Q', name: 'Walking 1-leg RDL (forward/backward)', video: 'https://youtu.be/hT-1t9dKbmE', documentation: '10 yards', sequence: 14 },
          { id: 'qrW.3HHDTzSe-PDC6mcdjQ', name: 'Heel-to-toe walk', video: 'https://youtu.be/MdF1oDS-AUs', documentation: '10 yards', sequence: 15 },
        ]
      },
      {
        id: 'strength_power',
        name: 'Strength/Power',
        sequence: 2,
        exercises: [
          { id: 'a-zDV0iXuSjGWWDnFYXFFIA', name: 'Side-lying leg raises', video: 'https://youtu.be/MS9bjd-R0-o', documentation: '10/side', sequence: 16 },
          { id: 'fE2vMHueSzq4WHXG-OHP6Q', name: 'Wall sit heel march', video: 'https://youtu.be/KD4EXUJROCs', documentation: '10/side', sequence: 17 },
          { id: 'sPEmw7vlTJKtT-hUq47FdQ', name: 'Foot fires (choppy feet)', video: 'https://youtu.be/erK7mUKEF_w', documentation: '20 seconds', sequence: 18 },
        ]
      },
    ]
  },
  
  phase_2: {
    categories: [
      {
        id: 'movement_prep',
        name: 'Movement Prep',
        sequence: 0,
        exercises: [
          { id: 'bUxN8PrGRXq0efbQShFZrA', name: 'Box ankle mobility', video: 'https://youtu.be/afuUw9Z9z9E', documentation: '10/side', sequence: 0 },
          { id: 'x3X2yo6cSmCJEwTjU0vZeg', name: 'Hamstring vertical leg lower (supported)', video: 'https://youtu.be/_yGmEQy-1jE', documentation: '10/side', sequence: 1 },
          { id: 'UDH7Yb05QpqeI3M6cNGWlQ', name: '90/90 hip switches (hands off floor)', video: 'https://youtu.be/6V1ArruXcXE', documentation: '5/side', sequence: 2 },
          { id: 'scUX7yK5Qry81UumQUZ-Wg', name: 'Half-kneeling quad stretch', video: 'https://youtu.be/THM0-m-KndM', documentation: '20 seconds/side', sequence: 3 },
          { id: 'Qlz5rl0USMCxr7kYXWXQrA', name: 'Lateral kneeling adductor', video: 'https://youtu.be/pxrc5KSuae4', documentation: '10/side', sequence: 4 },
          { id: '2Fyv9zinRpu7aM-LUDxvjA', name: 'Lumbar cat-cow', video: 'https://youtu.be/kAjce9C9iAw', documentation: '5/position', sequence: 5 },
          { id: 'zvLVFZJwTJasOh2DRdh4dQ', name: "World's greatest stretch (w/hamstring)", video: 'https://youtu.be/nFvIk3Eu5JM', documentation: '5/side', sequence: 6 },
          { id: 'KE74jkfoTk6kSFTYTga1kA', name: 'Side-lying thoracic arc', video: 'https://youtu.be/UOF3OQRTu4M', documentation: '10/side', sequence: 7 },
        ]
      },
      {
        id: 'speed_agility_locomotion',
        name: 'Speed/Agility/Locomotion',
        sequence: 1,
        exercises: [
          { id: '81Ltz3bvT7qRy3UXWT1dKw', name: 'A skips', video: 'https://youtu.be/uB4bCv7YhzE', documentation: '10 yards', sequence: 8 },
          { id: 'qqxmxzYCRrWo-SgQluyAww', name: 'Lateral skips', video: 'https://youtu.be/64OgQtiOHoQ', documentation: '10 yards/side', sequence: 9 },
          { id: '7kRmocsBR.-zUw52LPEmqQ', name: 'Side shuffle', video: 'https://youtu.be/DNJKboIrnlg', documentation: '10 yards/side', sequence: 10 },
          { id: 'gIiWgIIuSamsgwvI8JAeXw', name: 'Carioca', video: 'https://youtu.be/SGa5LkB-PKw', documentation: '10 yards/side', sequence: 11 },
          { id: 'ZqyWIiB0S0OWVM1iDW3J5w', name: 'Wall march switches', video: 'https://youtu.be/xtEALKVwc8k', documentation: '10/side', sequence: 12 },
          { id: 'yS9jnHbMS4mSa5pjtQYYPw', name: 'High knees', video: 'https://youtu.be/Jne-87IMpcU', documentation: '10 yards', sequence: 13 },
          { id: 'S0O0NLDOTmmxYpxGS5WN8g', name: 'Butt kickers', video: 'https://youtu.be/FOcHzBaMMUM', documentation: '10 yards', sequence: 14 },
          { id: 'gFTJVbW7QGCZw9lQjlMM7g', name: 'Lateral bear crawl', video: 'https://youtu.be/mpme3YRvzpM', documentation: '10 yards/side', sequence: 15 },
        ]
      },
      {
        id: 'strength_power',
        name: 'Strength/Power',
        sequence: 2,
        exercises: [
          { id: 't9tNLKUEQ1SCJd.yRDL22g', name: 'Kneeling hip thrusts', video: 'https://youtu.be/EPeOqS6x-Zs', documentation: '10 reps', sequence: 16 },
          { id: 'P3DKGYv.SCeuaR-3WjotkQ', name: 'Line jumps (linear & lateral)', video: 'https://youtu.be/LuRxZ0TCz5o', documentation: '20/direction', sequence: 17 },
          { id: 'aL91ftBqS2K1TINfn3XyCg', name: 'Box jumps (linear)', video: 'https://youtu.be/9VFy2grPHy8', documentation: '5 reps', sequence: 18 },
          { id: 'NNctAcQdR3K.SnoZlE2.fg', name: 'Drop lunges', video: 'https://youtu.be/MXJRI5wSNSw', documentation: '5/side', sequence: 19 },
          { id: 'BsgpKPdjR.GGq.LId73ivA', name: 'Broad jumps', video: 'https://youtu.be/tVWBOy1VPOo', documentation: '5 reps', sequence: 20 },
        ]
      },
      {
        id: 'balance',
        name: 'Balance',
        sequence: 3,
        exercises: [
          { id: '4.tZLL6NR6-LozCWFhLp7A', name: 'Half-kneeling (in-line) balance', video: 'https://youtu.be/2luoxJk2Ouc', documentation: '20 seconds/side', sequence: 21 },
          { id: '8i.Jy1jVSr2r7QveFtWXgA', name: 'Single-leg balance (eyes closed)', video: 'https://youtu.be/4Nu1npBzI9o', documentation: '20 seconds/side', sequence: 22 },
        ]
      },
    ]
  },
  
  phase_3: {
    categories: [
      {
        id: 'movement_prep',
        name: 'Movement Prep',
        sequence: 0,
        exercises: [
          { id: 'vjm-OLoaRVy2VFEzi.PBrA', name: 'Half-kneeling ankle mobility', video: 'https://youtu.be/DmhVXyTSJ6M', documentation: '10/side', sequence: 0 },
          { id: '8T0WEeLMSKatMi3smh-FFQ', name: 'Hamstring vertical leg lower', video: 'https://youtu.be/wBbgBK_n_r8', documentation: '10/side', sequence: 1 },
          { id: 'uhyaaQyfR8WyR3LBxO4MCQ', name: '90/90 position IR emphasis', video: 'https://youtu.be/nZUHQg0Gcv0', documentation: '5/side', sequence: 2 },
          { id: 'UccQFQE-RsS7FUYvTqQDTw', name: 'Half-kneeling quad stretch (active release)', video: 'https://youtu.be/Vlu7PAoUm0Q', documentation: '5/side', sequence: 3 },
          { id: 'NwQT-uSLQ16zxQHlef5zVw', name: 'Lateral squat', video: 'https://youtu.be/G5KtxHA6e78', documentation: '5/side', sequence: 4 },
          { id: '6zzstBolR2e9gTImRTzmyg', name: 'Thoracic cat-cow', video: 'https://youtu.be/sRvioYcMo8Q', documentation: '5/position', sequence: 5 },
          { id: 'aGoU1-Y4R3SGZf2.u75lzQ', name: "World's greatest stretch (elbow to instep)", video: 'https://youtu.be/M_K6f7wQ-So', documentation: '5/side', sequence: 6 },
          { id: '2L.Kqxh9TZGQEKE-weZvJA', name: 'Half-kneeling thoracic rotation', video: 'https://youtu.be/z5xnPSPm7Tc', documentation: '5/direction/side', sequence: 7 },
        ]
      },
      {
        id: 'speed_agility_locomotion',
        name: 'Speed/Agility/Locomotion',
        sequence: 1,
        exercises: [
          { id: '53Wng8PhSWG2g-d-X5uI3w', name: 'A & C skips (forward and backward)', video: 'https://youtu.be/h-5SeyXCLbk', documentation: '10 yards/direction/skip', sequence: 8 },
          { id: 'W6dXbeM9R9uqG3T3KsEqkw', name: 'Backpedal', video: 'https://youtu.be/v5VsOH6DnCY', documentation: '10 yards', sequence: 9 },
          { id: 'OSlxz9MRSKenxwjjoELong', name: 'Cross-over run', video: 'https://youtu.be/5K_21e7lV5E', documentation: '10 yards/side', sequence: 10 },
          { id: 'NLXlkjxaSBO0q5Ou9-YySA', name: 'Zig-zag run', video: 'https://youtu.be/8rtFACfiFo8', documentation: '10 yards', sequence: 11 },
          { id: 'M.oSQCAeSxitbSx6LwwuUQ', name: 'Y-Run (45° cut)', video: 'https://youtu.be/jcHdOeKjAjE', documentation: '2/side', sequence: 12 },
          { id: 'ES9YCDX.REOCxzcx7uufCA', name: 'Wall run', video: 'https://youtu.be/y5ozpIntaq4', documentation: '2 x 10 seconds', sequence: 13 },
          { id: '7q0cwIUkRHuVJ.afpRTOZA', name: 'Linear deceleration drill', video: 'https://youtu.be/SqUOZn-r_Xk', documentation: '5 reps', sequence: 14 },
        ]
      },
      {
        id: 'strength_power',
        name: 'Strength/Power',
        sequence: 2,
        exercises: [
          { id: 'Pe01H2hSS22OYyP5sWjiXg', name: 'Starfish side plank', video: 'https://youtu.be/jkIJGZsLMqM', documentation: 'Accumulate 20 seconds per side (take breaks as needed)', sequence: 15 },
          { id: 'BC05EZqUR6yRKsjvdVVpCg', name: 'Nordic hamstrings', video: 'https://youtu.be/3hKE9qw7mc0', documentation: '5 reps', sequence: 16 },
          { id: 'Sf6Vhxf9RiOGvrU1-MPA9A', name: 'Single-leg wall sit', video: 'https://youtu.be/oZkmZzhJShM', documentation: '20 seconds per side', sequence: 17 },
          { id: '7..7pp3fTxG4mO7sIyRYHA', name: 'Squat jumps (w/reset)', video: 'https://youtu.be/KNFEVxtL4vg', documentation: '5 reps', sequence: 18 },
          { id: 'EKWH5724QsmtdFnIq1LPBQ', name: 'Split jumps (2 levels)', video: 'https://youtu.be/Ah7DBsDJz5A', documentation: '5 reps/side', sequence: 19 },
          { id: 'W9qhZKxjTfO6AohssPgONA', name: 'Broad jumps (continuous)', video: 'https://youtu.be/Yk5zhRZU0TU', documentation: '5 reps', sequence: 20 },
        ]
      },
      {
        id: 'balance',
        name: 'Balance',
        sequence: 3,
        exercises: [
          { id: 'ZZqKzBU1RlGJPNeyKG8PyQ', name: 'Double pillow single-leg balance (w/ball toss)', video: 'https://youtu.be/-iJy4Qg2bIw', documentation: '20 seconds/side', sequence: 21 },
        ]
      },
    ]
  },
  
  phase_4: {
    categories: [
      {
        id: 'movement_prep',
        name: 'Movement Prep',
        sequence: 0,
        exercises: [
          { id: 'bKAl.Ey0T8iPov6caqpzgg', name: 'Weighted (half-kneeling) ankle mobility', video: 'https://youtu.be/gf7tnC85Y9U', documentation: '10/side', sequence: 0 },
          { id: 'KWWgc7NKR5ucbstUGBWoBg', name: 'Toe touch squat-to-stand', video: 'https://youtu.be/7yRwq6-4AFo', documentation: '5 reps', sequence: 1 },
          { id: 'YAMv93Q8T-isnNzqiI-ubg', name: 'Shin box', video: 'https://youtu.be/yewiShxzM60', documentation: '5/side', sequence: 2 },
          { id: '1s4DQI-yS4aZPBiOmkHvzw', name: 'Half-kneeling hip flexor stretch (w/hip flexion)', video: 'https://youtu.be/bPNwsIsueK8', documentation: '5/side', sequence: 3 },
          { id: 'CiteFdZFTg-4Usc4dtlvow', name: 'Lateral squat (side-to-side)', video: 'https://youtu.be/6_q_-2PIvf0', documentation: '5/side', sequence: 4 },
          { id: 'f-lBGzLNTdS2WhsjtoyV2A', name: 'Side bend cat-cow', video: 'https://youtu.be/tGNybHiuE5A', documentation: '5/side', sequence: 5 },
          { id: 'YW3XfZYETCCY2oYwoF7OSQ', name: "World's greatest stretch with opposite reach", video: 'https://youtu.be/RTiEX1_OQiw', documentation: '5/side', sequence: 6 },
          { id: 'gqF7D2-lTJqVhGCBIQWZZg', name: 'Reverse lunge with thoracic rotation', video: 'https://youtu.be/0b_FQDLFea0', documentation: '5/direction/side', sequence: 7 },
        ]
      },
      {
        id: 'speed_agility_locomotion',
        name: 'Speed/Agility/Locomotion',
        sequence: 1,
        exercises: [
          { id: 'FymlUsG4TMiarpwVTtVQ2A', name: 'A, C, & B skips', video: 'https://youtu.be/s9icN5EgIw4', documentation: '10 yards/skip', sequence: 8 },
          { id: '6MFA9DzsS.2IM2k1NyJOlQ', name: 'Linear sprints', video: 'https://youtu.be/EYtCzLTXKwo', documentation: '1/side x 20 yards (side denotes front foot in start)', sequence: 9 },
          { id: 'IwEvm5zLR-iVZyFd0GbaEw', name: '5-10-5 pro agility shuttle', video: 'https://youtu.be/Kk1KEcjPunA', documentation: '1/side', sequence: 10 },
          { id: '1Vyz9DUrSgSHA-a23T5ENQ', name: '5-10-5 shuffle', video: 'https://youtu.be/Dc1m4nFCugE', documentation: '1/side', sequence: 11 },
          { id: 'A1phs2iURaq.RGephidqWg', name: 'Circle run', video: 'https://youtu.be/yZy2beiea-s', documentation: '1/side', sequence: 12 },
          { id: 'xd3bJTNUS-iWw3gTaKqYuw', name: 'Side-step cut (60°-90°)', video: 'https://youtu.be/3VLXDhB8AXo', documentation: '1/side', sequence: 13 },
          { id: 'j41WUNpZTWShHNJ5O.dR9A', name: 'Lateral deceleration drills (hockey stop)', video: 'https://youtu.be/GVOcs6tFmbg', documentation: '1/side', sequence: 14 },
        ]
      },
      {
        id: 'strength_power',
        name: 'Strength/Power',
        sequence: 2,
        exercises: [
          { id: 'a.5bKek9vTKqEgKDwV3HXpw', name: 'Side plank & hip abduction', video: 'https://youtu.be/9nXZEJViZ7A', documentation: '10/side', sequence: 15 },
          { id: 'pHPlT1VRTXmbY6vuxoAE8Q', name: 'Nordic hamstrings', video: 'https://youtu.be/3hKE9qw7mc0', documentation: '5 reps', sequence: 16 },
          { id: 'pY6sgXi9T56tOdbbvGzPXQ', name: 'Rotational bound', video: 'https://youtu.be/XdkgPWGaaQs', documentation: '5/side', sequence: 17 },
          { id: 'YNi82nCkSbO0qU7nGa03ZA', name: 'Line jumps w/band (linear & lateral)', video: 'https://youtu.be/ksymYPrgAXY', documentation: '20/direction', sequence: 18 },
        ]
      },
      {
        id: 'balance',
        name: 'Balance',
        sequence: 3,
        exercises: [
          { id: 'Sx-XUvhyQa-mh2Md-wGLhQ', name: 'Double pillow single-leg balance (eyes closed)', video: 'https://youtu.be/YegSbo7mPtg', documentation: '20 seconds/side', sequence: 19 },
        ]
      },
    ]
  },
};

// Helper to get warmup exercises for a phase
export function getWarmupExercises(phaseNum) {
  return WARMUP_EXERCISES[`phase_${phaseNum}`] || null;
}

// Helper to get all exercises in a category
export function getExercisesByCategory(phaseNum, categoryId) {
  const phase = WARMUP_EXERCISES[`phase_${phaseNum}`];
  if (!phase) return [];
  const category = phase.categories.find(c => c.id === categoryId);
  return category?.exercises || [];
}

// Helper to flatten all warmup exercises for a phase
export function getAllWarmupExercises(phaseNum) {
  const phase = WARMUP_EXERCISES[`phase_${phaseNum}`];
  if (!phase) return [];
  return phase.categories.flatMap(cat => 
    cat.exercises.map(ex => ({ ...ex, category: cat.name, categoryId: cat.id }))
  );
}